import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/brandTheme/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/brandTheme/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/brandTheme/FETCH_FAILURE'

const CREATE_REQUEST = 'realhub/brandTheme/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/brandTheme/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/brandTheme/CREATE_FAILURE'

const UPDATE_REQUEST = 'realhub/brandTheme/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/brandTheme/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/brandTheme/UPDATE_FAILURE'

// Initial State
const initialState = {
  loaded: false,
  loading: false,
  creating: false,
  updating: false,
  loadedIds: [],
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadBrandThemes(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/admin/brand_themes.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.BRAND_THEME_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function loadBrandTheme(brandTheme, options){
  return (dispatch, getState) => {
    const { brandThemes } = getState()

    const loadedIds = brandThemes.loadedIds ? brandThemes.loadedIds.slice() : []
    if (!loadedIds.includes(brandTheme.id)){
      loadedIds.push(brandTheme.id)
    }

    dispatch(fetchRequest({ loadedIds }))

    const promise = api(`/admin/brand_themes/${brandTheme.id}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.BRAND_THEME)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createBrandTheme(brand_theme, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      brand_theme,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/admin/brand_themes.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.BRAND_THEME)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function updateBrandTheme(brand_theme, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      brand_theme,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/admin/brand_themes/${brand_theme.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.BRAND_THEME)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        result: action.result,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
